<template>
  <div class="wrapper" :class="{english:lang=='EN'}" ref="partnerWrapper">
    <Header ref="partnerHeader" id="partnerHeader"></Header>
    <div style="width: 100%;" ref="partnerBanner">
      <div class="hidden-xs">
        <img class="img-fluid" src="../assets/img/partner/header_banner.png" alt="">
      </div>
      <div class="visible-xs">
        <img ref="bannerImg" style="margin-top: 3.5rem;" class="img-fluid" src="../assets/img/partner/header_banner.png"
             alt="">
      </div>
    </div>
    <div style="width: 100%;height: auto;" :class="{operateFixed:isOperateFixed}" ref="partnerOperate">
      <div class="hidden-xs">
        <div class="operateOL">
          <div class="operate">
            <div class="left">{{$t('partner.partner')}}</div>
            <div class="right">
              <span class="tec-btn" v-for="item in tabs" :class="{actived:curMenu==item.label}" @click="goAnchor(item)">
                {{$t(item.name)}}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="visible-xs">
        <div class="operate-ol-xs">
          <div class="operate">
            <div class="title">{{$t('partner.partner')}}</div>
            <div class="dropdown">
              <div class="dropdown-toggle"  type="button" id="dropdownMenu3" data-toggle="dropdown"
                   aria-haspopup="true" aria-expanded="true">
                {{$t(curMenuName)}}<i class="el-icon-arrow-down el-icon--right"></i>
              </div>
              <ul class="dropdown-menu dropdown-ul dropdown-menu-right" aria-labelledby="dropdownMenu3">
                <li v-for="item in tabs" @click="goAnchor(item)">{{$t(item.name)}}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="width: 100%;" ref="anchorTec">
      <div class="hidden-xs">
        <div class="tec-partner-ol">
          <div class="technology-partner">
            <div class="title wow fadeInUp">{{$t('partner.technology')}}</div>
            <div class="tec-partner-ul animated wow fadeInUp">
              <div class="item" v-for="item in tecPartnerArr">
                <img :src="item.img"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="visible-xs">
        <div class="tec-partner-ol">
          <div class="technology-partner">
            <div class="title wow fadeInUp">{{$t('partner.technology')}}</div>
            <div class="tec-partner-ul animated wow fadeInUp">
              <div class="item" v-for="item in tecPartnerArr">
                <img :src="item.img"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="width: 100%;" ref="anchorMoney">
      <div class="hidden-xs">
        <div class="money-partner-ol">
          <div class="money-partner">
            <div class="title wow fadeInUp">{{$t('partner.business')}}</div>
            <div class="money-partner-ul">
              <div class="item-li">
                <div class="item-img">
                  <img src="../assets/img/partner/img1.png">
                </div>
                <div class="item-right animated wow fadeInUp">
                  <div class="title">{{$t('partner.Singapore')}}</div>
                  <div class="message" style="height: 70%">{{$t('partner.message')}}
                  </div>
                  <div class="operate-button">
                    <div @click="openRouter('airPort')" class="understand-more">
                      {{$t('common.learnMore')}}
                      <div class="unserstand-more-logo"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="visible-xs">
        <div class="money-partner-ol">
          <div class="money-partner">
            <div class="title wow fadeInUp">{{$t('partner.business')}}</div>
            <div class="money-partner-ul">
              <div class="item-li">
                <div class="item-right animated wow fadeInUp">
                  <div class="item-img">
                    <img src="../assets/img/solutions/airport/bk-banner.png">
                  </div>
                  <div class="title">{{$t('partner.Singapore')}}</div>
                  <div class="message" style="height: 70%">{{$t('partner.message')}}
                  </div>
                  <div class="operate-button">
                    <div @click="openRouter('airPort')" class="understand-more">
                      {{$t('common.learnMore')}}
                      <div class="unserstand-more-logo"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer></Footer>
  </div>
</template>
<script>
  import Header from '@/components/common/Header'
  import Footer from '@/components/common/Footer'
  import {mapGetters} from 'vuex'

  export default {
    name: 'Partner',
    components: {
      Header,
      Footer
    },
    props: {},
    data() {
      return {
        isOperateFixed: false,
        curMenu: 'anchorTec',
        curMenuName: 'partner.technology',
        tabs: [
          {
            label: 'anchorTec',
            name: 'partner.technology'
          },
          {
            label: 'anchorMoney',
            name: 'partner.business'
          }
        ],
        tecPartnerArr: [
          {
            img: require('../assets/img/common/tec_partner1.png'),
            imgPath: require('../assets/img/common/tec_partner1.png'),
            imgActivePath: require('../assets/img/common/tec_partner1.png')
          },
          {
            img: require('../assets/img/common/tec_partner2.png'),
            imgPath: require('../assets/img/common/tec_partner2.png'),
            imgActivePath: require('../assets/img/common/tec_partner2.png')
          },
          {
            img: require('../assets/img/common/tec_partner3.png'),
            imgPath: require('../assets/img/common/tec_partner3.png'),
            imgActivePath: require('../assets/img/common/tec_partner3.png')
          },
          {
            img: require('../assets/img/common/tec_partner4.png'),
            imgPath: require('../assets/img/common/tec_partner4.png'),
            imgActivePath: require('../assets/img/common/tec_partner4.png')
          },
          {
            img: require('../assets/img/common/tec_partner5.png'),
            imgPath: require('../assets/img/common/tec_partner5.png'),
            imgActivePath: require('../assets/img/common/tec_partner5.png')
          }
        ]
      }
    },
    methods: {
      changeItemImg(item) {
        item.img = item.imgPath
      },
      changeItemImgActive(item) {
        item.img = item.imgActivePath
      },
      scrollEvent() {
        let screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        if (scrollTop > 0) {
          this.$refs.partnerHeader.setHeaderFixed(true)
          if (screenWidth >= 768) {
            if (scrollTop > this.$refs.partnerBanner.offsetHeight - this.$refs.partnerOperate.offsetHeight) {
              $('#partnerHeader').slideUp('fast')
              this.isOperateFixed = true
            } else {
              $('#partnerHeader').slideDown('fast')
              this.isOperateFixed = false
            }
          } else {
            if (scrollTop > this.$refs.bannerImg.offsetHeight) {
              $('#partnerHeader').slideUp('fast')
              this.isOperateFixed = true
            } else {
              $('#partnerHeader').slideDown('fast')
              this.isOperateFixed = false
            }
          }
        } else {
          this.isOperateFixed = false
          $('#header').slideDown('fast')
          this.$refs.partnerHeader.setHeaderFixed(false)
        }
        // 设置锚点双向绑定
        if (scrollTop >= this.$refs.anchorTec.offsetTop - this.$refs.partnerOperate.offsetHeight) {
          this.curMenu = 'anchorTec'
          this.curMenuName = 'partner.technology'
        }
        if (scrollTop >= this.$refs.anchorMoney.offsetTop - this.$refs.partnerOperate.offsetHeight) {
          this.curMenu = 'anchorMoney'
          this.curMenuName = 'partner.business'
        }
      },
      goAnchor(item) {
        let selector = item.label
        this.curMenu = selector
        this.curMenuName = item.name
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop

        let bannerImgHeight = this.$refs.bannerImg.offsetHeight || this.$refs.partnerBanner.offsetHeight
        if (selector === 'anchorTec') {
          if (this.isOperateFixed) {
            $('html,body').animate({
              scrollTop: this.$refs.anchorTec.offsetTop - this.$refs.partnerOperate.offsetHeight + 1
            }, 300)
          } else {
            $('html,body').animate({
              scrollTop: this.$refs.anchorTec.offsetTop - this.$refs.partnerOperate.offsetHeight * 2 + 1
            }, 300)
          }
        }
        if (selector === 'anchorMoney') {
          if (this.isOperateFixed) {
            $('html,body').animate({
              scrollTop: this.$refs.anchorMoney.offsetTop - this.$refs.partnerOperate.offsetHeight + 1
            }, 300)
          } else {
            $('html,body').animate({
              scrollTop: this.$refs.anchorMoney.offsetTop - this.$refs.partnerOperate.offsetHeight * 2 + 1
            }, 300)
          }
        }
        return
      },
      openRouter(name) {
        this.$router.push({
          name: name
        })
      }
    },
    mounted() {
      $('html,body').scrollTop(0)
      window.addEventListener('scroll', this.scrollEvent)
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.scrollEvent)
    },
    computed: {
      ...mapGetters(['lang']),
      getComponentName() {
        return 'Partner'
      }
    }

  }
</script>

<style lang="scss" scoped>
  .wrapper {
    background: #F3F6FB;
    width: 100%;

    .operateFixed {
      position: fixed;
      top: 0;
      z-index: 1001;
      box-shadow: 0rem 0rem 0.75rem 0rem rgba(179, 193, 218, 0.41);
    }

    .banner {
      background: url("../assets/img/partner/header_banner.png") no-repeat;
      height: 30rem;
      background-size: contain;
      -webkit-background-size: contain;
      -o-background-size: contain;
      background-position: center 0;
    }

    .operateOL {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      background: #FFFFFF;

      .operate {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 1.35rem;
        font-family: Arial, Source Han Sans CN;
        font-weight: bold;
        color: rgba(63, 74, 93, 1);
        line-height: 4.5rem;
        background: #FFFFFF;
        max-width: 75rem;
        width: 100%;

        .tec-btn, .money-btn {
          font-size: 1rem;
          font-family: Arial, Source Han Sans CN;
          font-weight: 400;
          cursor: pointer;
          margin: 0 0.8rem;
        }

        .actived {
          color: #2D8FFF;
        }

        .tec-btn:hover, .money-btn:hover {
          color: #2D8FFF;
        }
      }
    }

    .visible-xs {
      .operate-ol-xs {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        background: #FFFFFF;

        .operate {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 3.5rem;
          background: #FFFFFF;
          max-width: 90%;
          width: 100%;

          .title {
            font-size: 1rem;
            font-family: Arial, Source Han Sans CN;
            font-weight: 300;
            color: rgba(63, 74, 93, 1);
            line-height: 3.5rem;
          }

          .tec-btn, .money-btn {
            font-size: 1rem;
            font-family: Arial, Source Han Sans CN;
            font-weight: 400;
            cursor: pointer;
          }

          .actived {
            color: #2D8FFF;
          }

          .tec-btn:hover, .money-btn:hover {
            color: #2D8FFF;
          }

          .el-dropdown-link:focus {
            outline: 0;
          }

          .el-dropdown-menu__item {
            text-align: center;
          }

          .dropdown-ul {
            margin-top: 0.5rem;
            width: 3rem;

            li {
              text-align: center;
              margin: 0.8rem 0;
            }
          }
        }
      }
    }

    .tec-partner-ol {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      padding-top: 8rem;

      .technology-partner {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        max-width: 75rem;

        .title {
          font-size: 3rem;
          font-family: Arial, Source Han Sans CN;
          font-weight: 400;
          color: rgba(63, 74, 93, 1);
          letter-spacing: 0.25rem;
        }

        .underline {
          padding-top: 1.5rem;
          width: 9.75rem;
        }

        .tec-partner-ul {
          width: 100%;
          margin-top: 6rem;
          display: flex;
          justify-content: space-between;

          .item {
            width: 8.25rem;
            height: 8.25rem;
            display: flex;
            justify-content: center;
            align-items: center;

            img {
              max-width: 8.25rem;
              max-height: 8.25rem;
            }
          }
        }
      }
    }

    .visible-xs {
      .tec-partner-ol {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        padding-top: 2rem;

        .technology-partner {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 100%;
          max-width: 90%;

          .title {
            font-size: 1.5rem;
            font-family: Arial, Source Han Sans CN;
            font-weight: 400;
            color: rgba(63, 74, 93, 1);
            letter-spacing: 0.1rem;
          }


          .tec-partner-ul {
            width: 100%;
            margin-top: 2rem;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;

            .item {
              width: 50%;
              height: 50%;
              display: flex;
              justify-content: center;
              align-items: center;
              width: 45%;
              height: 6rem;
              margin: 2.5%;
              background: #FFFFFF;

              img {
                height: 4rem;
                width: auto;

              }
            }
          }
        }
      }
    }

    .money-partner-ol {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      padding-top: 11rem;

      .money-partner {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        max-width: 75rem;

        .title {
          font-size: 3rem;
          font-family: Arial, Source Han Sans CN;
          font-weight: 400;
          color: rgba(63, 74, 93, 1);
          letter-spacing: 0.25rem;
        }

        .underline {
          padding-top: 1.5rem;
          width: 9.75rem;
        }

        .money-partner-ul {
          width: 100%;
          margin-top: 6rem;
          height: auto;

          .item-li {
            height: 24.75rem;
            padding: 2.25rem;
            background: #FFFFFF;
            display: flex;
            justify-content: space-between;
            margin-bottom: 2.25rem;
            box-shadow: 0rem 0rem 0.1rem 0rem rgba(179, 193, 218, 0.41);

            .item-img {
              width: 24rem;
              height: 21rem;
              margin-right: 6rem;

              img {
                max-width: 24rem;
                max-height: 21rem;
              }
            }

            .item-right {
              display: flex;
              flex-direction: column;
              width: 100%;
              max-width: 45rem;

              .title {
                font-size: 1.63rem;
                font-family: Arial, Source Han Sans CN;
                font-weight: 300;
                color: rgba(63, 74, 93, 1);
                line-height: 4.38rem;
              }

              .message {
                font-size: 0.88rem;
                font-family: Arial, Source Han Sans CN;
                font-weight: 300;
                color: rgba(142, 146, 153, 1);
                line-height: 1.875rem;
              }

              .operate-button {
                width: 100%;

                .understand-more {
                  float: right;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  width: 10.5rem;
                  height: 3.15rem;
                  background: url("../assets/img/mainpage/button01.png") no-repeat;
                  background-size: contain;

                  .unserstand-more-logo {
                    background: url("../assets/img/mainpage/arrow_black.png") no-repeat;
                    background-size: contain;
                    width: 1.21rem;
                    height: 0.525rem;
                    margin-left: 0.375rem;
                  }
                }

                .understand-more:hover {
                  background: url("../assets/img/mainpage/button01_active.png") no-repeat;
                  background-size: contain;
                  color: #FFFFFF;

                  .unserstand-more-logo {
                    background: url("../assets/img/mainpage/Arrow.png") no-repeat;
                    background-size: contain;
                    width: 1.21rem;
                    height: 0.525rem;
                    margin-left: 0.375rem;
                  }
                }
              }
            }
          }

          .item-li:hover {
            box-shadow: 0rem 0rem 2.25rem 0rem rgba(179, 193, 218, 0.41);
          }
        }
      }
    }

    .visible-xs {
      .money-partner-ol {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        padding-top: 2rem;

        .money-partner {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 100%;
          max-width: 95%;

          .title {
            font-size: 1.5rem;
            font-family: Arial, Source Han Sans CN;
            font-weight: 400;
            color: rgba(63, 74, 93, 1);
            letter-spacing: 0.25rem;
          }

          .money-partner-ul {
            width: 100%;
            margin-top: 2rem;
            height: auto;

            .item-li {
              height: auto;
              padding: 1rem;
              background: #FFFFFF;
              display: flex;
              justify-content: space-between;
              margin-bottom: 2.25rem;
              box-shadow: 0rem 0rem 0.1rem 0rem rgba(179, 193, 218, 0.41);

              .item-right {
                display: flex;
                flex-direction: column;
                width: 100%;
                max-width: 45rem;

                .item-img {
                  width: 100%;
                  height: auto;
                  margin-right: 6rem;

                  img {
                    max-width: 100%;
                    max-height: 100%;
                  }
                }

                .title {
                  font-size: 1rem;
                  font-family: Arial, Source Han Sans CN;
                  font-weight: 400;
                  color: rgba(63, 74, 93, 1);
                  line-height: 3rem;
                }

                .message {
                  margin-top: 0.5rem;
                  text-indent: 2em;
                  font-size: 0.8rem;
                  font-family: Arial, Source Han Sans CN;
                  font-weight: 300;
                  color: rgba(142, 146, 153, 1);
                  line-height: 1.875rem;
                }

                .operate-button {
                  margin-top: 1rem;
                  width: 100%;

                  .understand-more {
                    float: right;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 8.0625rem;
                    height: 2.3925rem;
                    background: url("../assets/img/mainpage/button01.png") no-repeat;
                    background-size: contain;

                    .unserstand-more-logo {
                      background: url("../assets/img/mainpage/arrow_black.png") no-repeat;
                      background-size: contain;
                      width: 0.726rem;
                      height: 0.315rem;
                      margin-left: 0.187rem;
                    }
                  }

                  .understand-more:hover {
                    background: url("../assets/img/mainpage/button01_active.png") no-repeat;
                    background-size: contain;
                    color: #FFFFFF;

                    .unserstand-more-logo {
                      background: url("../assets/img/mainpage/Arrow.png") no-repeat;
                      background-size: contain;
                      width: 0.726rem;
                      height: 0.315rem;
                      margin-left: 0.187rem;
                    }
                  }
                }
              }
            }

            .item-li:hover {
              box-shadow: 0rem 0rem 2.25rem 0rem rgba(179, 193, 218, 0.41);
            }
          }
        }
      }
    }
  }

  .english {
    .title {
      letter-spacing: 0 !important;
    }

    .hidden-xs {
      .item-img {
        margin-right: 2rem !important;
      }

      .item-right {
        .title {
          line-height: 3rem !important;
        }

        .message {
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 7;
          /*word-break: break-all;*/
          -webkit-box-orient: vertical;
          display: -webkit-box;
        }

        .operate-button {
          padding-top: 2%;
        }
      }
    }

    .visible-xs {
      .dropdown-ul {
        margin-left: -1.5rem !important;
      }

      .message {
        word-break: break-word;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Partner.vue